import {
  Box,
  Center,
  Heading,
  SimpleGrid,
  GridItem,
  Grid,
  Flex,
  Stack,
  Text,
  useColorModeValue as mode,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  FormControl,
  Input,
  ModalCloseButton,
  FormLabel,
  ModalFooter,
  Img,
  theme,
  Button,
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList,
  TagLabel,
  Tag,
  Icon,
  HStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { Logo } from "components/logo";
import * as React from "react";
import { PricingCard } from "./pricing-card";
import { useSession } from "next-auth/react";
import { useRouter } from "next/dist/client/router";
import { firebaseClient } from "../../firebaseClient";
import * as analytics from "../../utils/analytics";
import {
  updateEmail,
  guessTimezone,
  initUserAnalytics,
} from "../../controllers/settings";
import { warm } from "../../controllers/search";
import { getPeriodicity } from "../../controllers/subscription";
import ShoutoutEmbed from "shoutout-react";
import { MdCheckCircle } from "react-icons/md";
import Payment from "components/payment";
import { SocialProof } from "../social-proof";
import { GiftGuide } from "../gift-guide";
import { prices, discounts } from "./pricing";
import { format } from "date-fns";
import { OnboardNewChoice } from "components/onboard-new-choice";

// let now = new Date();
// // let now = new Date(2021,8,18,0,0,0);
// let startCounterDate = new Date(2022,4,3,0,0,0);
// let endCounterDate = new Date(2022,4,6,23,59,59);
// let diffDate = endCounterDate.getTime() - startCounterDate.getTime();
// let startCount = 141;
// let endCount = 7;

export const PlansLeaders = ({
  discount,
  billingFrequency,
  customCancelUrl = undefined as string | undefined,
  withCounter = false,
  ...rest
}) => {
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"
  const [refresh, setRefresher] = React.useState({});
  const originalDiscount = discount;

  // let diff = endCounterDate.getTime() - Date.now();
  // let nbDays: any = Math.floor(diff/24/3600/1000);
  // let nbHours: any = Math.floor(diff/3600/1000)%24;
  // if (nbHours < 10) nbHours = "0" + nbHours;
  // let nbMinutes: any = Math.floor(diff/60/1000)%60;
  // if (nbMinutes < 10) nbMinutes = "0" + nbMinutes;
  // let nbSeconds: any = Math.floor(diff/1000)%60;
  // if (nbSeconds < 10) nbSeconds = "0" + nbSeconds;

  var globalPromotion;
  // // to activate when you want a counter
  // let ratio = (now.getTime() - startCounterDate.getTime()) / diffDate;
  // let counter = Math.round(startCount - (ratio * (startCount-endCount)));
  // if (counter < endCount) counter = endCount;
  // // console.log("ratio: " + ratio);
  // // console.log("counter: " + counter);
  // if (now > startCounterDate && now < endCounterDate) {
  //     globalPromotion = {code: "", message: (<Box whiteSpace="pre-line"><Text fontSize="2xl" >{"Launch Offer 🎉"}</Text><Text mt={2} fontWeight="800" fontSize="lg">{`Only ${counter} / 200 Taplio seats left with discounted price`}</Text></Box>)};
  // }

  React.useEffect(() => {
    setInterval(() => {
      // console.log("refresh");
      setRefresher({});
    }, 1000);
  }, []);

  return <OnboardNewChoice {...{ discount, query: {}, withCounter }} forceBillingFrequency={billingFrequency} />;

  // return (
  //   <Flex
  //     flexDir="column"
  //     key="plans-root"
  //     id="plans-root"
  //     justifyContent="center"
  //     mt={0}
  //     mb={10}
  //   >
  //     {globalPromotion && (
  //       <Box mt={5}>
  //         <Box
  //           p={5}
  //           key="banner"
  //           id="banner"
  //           justifyContent="center"
  //           // border="4px"
  //           maxWidth="lg"
  //           margin="auto"
  //           // borderRadius="lg"
  //           // borderColor="#da5630"
  //           bg="gray.900"
  //           color="white"
  //           rounded="lg"
  //           textAlign="center"
  //         >
  //           {globalPromotion.message}
  //         </Box>
  //       </Box>
  //     )}

  //     <Center mt={10}>
  //       <Flex flexDirection="column" alignItems="flex-start" maxW="420px">
  //         {/* <Flex mb={10} flexDirection="column" alignItems="flex-start">
  //                       <Text mt={0} color={mode("gray.800", "gray.100")} mx="auto" fontSize="2xl" fontWeight="600" >
  //                           Price increase at launch
  //                       </Text>
  //                       <Text mt={0} color={mode("gray.800", "gray.100")} mx="auto" fontSize="md" fontWeight="400" >
  //                           Secure your price now
  //                       </Text>
  //                       <Flex mt={10}>
  //                           {
  //                               [
  //                                   {text: "days", value: nbDays},
  //                                   {text: "hours", value: nbHours},
  //                                   {text: "minutes", value: nbMinutes},
  //                                   {text: "seconds", value: nbSeconds},
  //                               ].map((e, index) => (
  //                                   <Flex key={"time"+index} w="100px" flexDir="column" alignItems="center">
  //                                       <Text fontSize="5xl">{e.value}</Text>
  //                                       <Text color="gray.500" >{e.text}</Text>
  //                                   </Flex>
  //                               ))
  //                           }
  //                       </Flex>
  //                       <Text mt={5} color={mode("gray.800", "gray.100")} mx="auto" fontSize="lg" fontWeight="400" fontStyle="italic" >
  //                           Before price increase
  //                       </Text>
  //                   </Flex> */}

  //         {[
  //           { title: "Get inspired with the best posts on your topics" },
  //           { title: "New AI generated post every day" },
  //           { title: "Generate AI variations of your favorite posts" },
  //           { title: "News from your industry picked by AI" },
  //           { title: "Schedule all your content in 1 place" },
  //           { title: "Post automations you have never seen before" },
  //           { title: "Engage with relevant posts to grow faster" },
  //           { title: "Export and manage lists of people" },
  //           { title: "Send personalized bulk DMs" },
  //         ].map((e, index) => {
  //           return (
  //             <List key={index} spacing={50}>
  //               <ListItem mt={6} display="flex">
  //                 <ListIcon
  //                   as={MdCheckCircle}
  //                   color={mode("gray.600", "gray.100")}
  //                   fontSize="20px"
  //                 />
  //                 <Text fontWeight="500">{e.title}</Text>
  //               </ListItem>
  //             </List>
  //           );
  //         })}
  //       </Flex>
  //     </Center>
  //     <Center mt={10}>
  //       <Flex direction="column" justify="center" alignItems="center">
  //         <Payment
  //           // color="blue.400"
  //           discount={discount}
  //           textColor={mode("white", "gray.900")}
  //           plan={billingFrequency === "yearly" ? "growYearly" : "growMonthly"}
  //           billingFrequency={billingFrequency}
  //           session={session}
  //           customCancelUrl="onboardnew"
  //           source="onboardNew"
  //           onClickStartFreeTrial={() => {
  //             console.log("click start trial");
  //             if (session?.user?.data && !session.user.data.description) {
  //               console.log("call warm");
  //               warm(session);
  //             }
  //           }}
  //         />
  //         <Flex>
  //           <Text
  //             align="center"
  //             mt="5"
  //             color={mode("gray.800", "gray.100")}
  //             // maxW="16rem"
  //             mx="auto"
  //             // fontWeight="bold"
  //             fontSize="lg"
  //           >
  //             Then
  //           </Text>
  //           <Text
  //             align="center"
  //             mt="5"
  //             pl="1"
  //             color={mode("gray.800", "gray.100")}
  //             // maxW="16rem"
  //             mx="auto"
  //             // fontWeight="bold"
  //             fontSize="xs"
  //             textDecoration="line-through"
  //           >
  //             $49
  //           </Text>
  //           <Text
  //             align="center"
  //             mt="5"
  //             pl="1"
  //             color={mode("gray.800", "gray.100")}
  //             // maxW="16rem"
  //             mx="auto"
  //             // fontWeight="bold"
  //             fontSize="lg"
  //           >
  //             $39 / month
  //             <Box as="span" ml={2} style={{ fontSize: "12px" }}>
  //               (launch offer)
  //             </Box>
  //           </Text>
  //         </Flex>
  //         <Text
  //           align="center"
  //           mt="5"
  //           color={mode("gray.800", "gray.100")}
  //           // maxW="16rem"
  //           mx="auto"
  //           fontStyle="italic"
  //           fontSize="sm"
  //         >
  //           30-day money-back guarantee.
  //         </Text>
  //         <Text
  //           align="center"
  //           color={mode("gray.800", "gray.100")}
  //           // maxW="16rem"
  //           mx="auto"
  //           fontStyle="italic"
  //           fontSize="sm"
  //         >
  //           no questions asked.
  //         </Text>
  //       </Flex>
  //     </Center>
  //   </Flex>
  // );
};


